export const useStyles = () => ({
  button: { padding: '0 !important', border: 'none', overflow: 'hidden' },
});
